import type { ValueOf } from '@shared/types/utilities';

export const CURRENCY = {
  egp: 'EGP',
  jod: 'JOD',
  usd: 'USD',
  euro: 'EURO',
} as const;

export type TCurrency = ValueOf<typeof CURRENCY>;
